export default __webpack_public_path__ + "static/media/phone-on.890b2e1e.svg";